




import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import store from '@/store';
import * as CvSectionSkillItemStoreNew from '@/store/modules/cvSectionSkillItemNew';

import NewContainer from '@/containers/cv-section-skill-item/new.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionSkillItemStoreNew.namespace
);

const fetch = async params => {
  const { cv_id, cv_section_skill_id } = params;
  await store.dispatch(
    CvSectionSkillItemStoreNew.GetCvSectionSkill.namespaced({
      params: { cv_id, id: cv_section_skill_id },
    })
  );
};

export default Vue.extend({
  components: {
    NewContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionSkillItemStoreNew],
    };
  },
  computed: {
    ...mapGetters(['cvSectionSkill']),
  },
});
